import { validateEnumTranslations } from '../../safety_checks';

/**
 * Fusion de fiches clients — enums partagés (API only, PAS d'enum Prisma : les
 * tiers/signaux sont dérivés à la volée par le moteur de détection, jamais
 * persistés). cf. plan « fusion fiches clients ».
 */

/** Niveau de confiance d'une proposition de doublon (jamais de fusion automatique). */
export enum ProCustomerDuplicateTier {
  SURE = 'SURE',
  PROBABLE = 'PROBABLE',
  TO_CHECK = 'TO_CHECK',
}

/**
 * Signaux expliquant au pro POURQUOI deux fiches sont proposées (ou nuançant la
 * proposition : NAMES_DIFFER / FIRSTNAME_DIFFERS signalent un email familial ou
 * un téléphone de foyer sans changer le tier — décision D3).
 */
export enum ProCustomerDuplicateSignal {
  SAME_EMAIL = 'SAME_EMAIL',
  SAME_PHONE = 'SAME_PHONE',
  SAME_LASTNAME = 'SAME_LASTNAME',
  SAME_FIRSTNAME = 'SAME_FIRSTNAME',
  SAME_BIRTHDAY = 'SAME_BIRTHDAY',
  SIMILAR_NAME = 'SIMILAR_NAME',
  NAMES_DIFFER = 'NAMES_DIFFER',
  FIRSTNAME_DIFFERS = 'FIRSTNAME_DIFFERS',
  BIRTHDAY_DIFFERS = 'BIRTHDAY_DIFFERS',
}

/** Avertissements affichés dans l'aperçu de fusion avant confirmation. */
export enum ProCustomerMergeWarning {
  STRIPE_CUSTOMER_DROPPED = 'STRIPE_CUSTOMER_DROPPED',
  STRIPE_SAVED_PAYMENT_AT_RISK = 'STRIPE_SAVED_PAYMENT_AT_RISK',
  MARKETING_CONSENT_TIGHTENED = 'MARKETING_CONSENT_TIGHTENED',
  BANNED_TAG_INHERITED = 'BANNED_TAG_INHERITED',
}

export const TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER = 'PRO_CUSTOMER_DUPLICATE_TIER_';
export const TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL = 'PRO_CUSTOMER_DUPLICATE_SIGNAL_';
export const TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING = 'PRO_CUSTOMER_MERGE_WARNING_';

export const ProCustomerDuplicateTierTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER}${ProCustomerDuplicateTier.SURE}`]: 'Doublon quasi certain',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER}${ProCustomerDuplicateTier.PROBABLE}`]: 'Doublon probable',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER}${ProCustomerDuplicateTier.TO_CHECK}`]: 'À vérifier',
  },
};

export const ProCustomerDuplicateSignalTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.SAME_EMAIL}`]: 'Même email',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.SAME_PHONE}`]: 'Même téléphone',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.SAME_LASTNAME}`]: 'Même nom',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.SAME_FIRSTNAME}`]: 'Même prénom',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.SAME_BIRTHDAY}`]:
      'Même date de naissance',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.SIMILAR_NAME}`]: 'Noms très proches',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.NAMES_DIFFER}`]:
      'Noms différents (email partagé ?)',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.FIRSTNAME_DIFFERS}`]:
      'Prénoms différents (téléphone partagé ?)',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL}${ProCustomerDuplicateSignal.BIRTHDAY_DIFFERS}`]:
      'Dates de naissance différentes',
  },
};

export const ProCustomerMergeWarningTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING}${ProCustomerMergeWarning.STRIPE_CUSTOMER_DROPPED}`]:
      'Les deux fiches ont un profil de paiement Stripe : celui de la fiche archivée ne sera plus utilisé.',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING}${ProCustomerMergeWarning.STRIPE_SAVED_PAYMENT_AT_RISK}`]:
      'La fiche archivée porte une empreinte bancaire ou une carte enregistrée : vérifiez vos encaissements en attente.',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING}${ProCustomerMergeWarning.MARKETING_CONSENT_TIGHTENED}`]:
      'Un refus de communication est conservé : la fiche fusionnée ne sera pas réabonnée.',
    [`${TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING}${ProCustomerMergeWarning.BANNED_TAG_INHERITED}`]:
      'La fiche archivée était bloquée : la fiche conservée hérite du blocage.',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  ProCustomerDuplicateTier,
  ProCustomerDuplicateTierTranslation,
  TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER,
  true,
);
validateEnumTranslations(
  ProCustomerDuplicateSignal,
  ProCustomerDuplicateSignalTranslation,
  TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL,
  true,
);
validateEnumTranslations(
  ProCustomerMergeWarning,
  ProCustomerMergeWarningTranslation,
  TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING,
  true,
);
